import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Skeleton,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import "../css/NewAgentViewerScreen.css";
import { useDispatch, useSelector } from "react-redux";
import DescriptionIcon from '@mui/icons-material/Description';
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
} from "chart.js";
import { statusAiAgent } from "../redux/slices/StatusProgressSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getStatisticsAgents } from "../redux/slices/StatisticsSlice";
import {
  deployAiAgent,
  resetDeployAgent,
  saveTaskId,
} from "../redux/slices/DeployAIAgent";
import { processedDocuments } from "../redux/slices/LoadAIAgentsSlice";
import { getProgressLoading } from "../redux/slices/ActiveSystemAiAgentLists";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { LinearProgress, Avatar, Paper } from "@mui/material";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import TaskIcon from "@mui/icons-material/Task";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DoughnutProgressCard from "../components/DoughnutProgressCard";
import StatusProgress from "../components/StatusProgress";
import BlueTile from "../components/BlueTile";
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);
const sparklineData = {
  labels: ["1", "2", "3", "4", "5"],
  datasets: [
    {
      data: [1, 3, 2, 4, 3],
      borderColor: "#ffffffaa", // white with alpha
      borderWidth: 2,
      pointRadius: 0,
      fill: false,
      tension: 0.3,
    },
  ],
};

const sparklineOptions = {
  responsive: true,
  maintainAspectRatio: false,
  elements: {
    line: { tension: 0.3 },
  },
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
  scales: {
    x: { display: false },
    y: { display: false },
  },
};

const NewAgentViewerScreen = () => {
  const DeploySliceData = useSelector((state) => state.DeploySlice);
  const { progressindData } = useSelector(
    (state) => state.ActiveSystemAiAgentLists
  );
  const { profileDetails: profile } = useSelector(
    (state) => state.ProfileSlice
  );
  const { processedDocumentsList } = useSelector(
    (state) => state.LoadAIAgentsSlice
  );
  console.log("processedDocumentsList", processedDocumentsList);
  const { slugName } = useSelector((state) => state.CreateAgentSlice);

  const { deployAgentLoading, deployAgent } = useSelector(
    (state) => state.DeploySlice
  );
  const { statusAgent, statusAgentLoading } = useSelector(
    (state) => state.StatusProgressSlice
  );
  const { statisticInfo, statisticInfoLoading } = useSelector(
    (state) => state.StatisticsSlice
  );
  console.log("statisticInfo", statisticInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const receviedDatafromProps = location.state;
  const [durationFilter, setDurationFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // to deploye the AI agents
  useEffect(() => {
    if (DeploySliceData?.taskId == null) {
      handleRunAIAgent();
    }
  }, [DeploySliceData]);

  useEffect(() => {
    let intervalId;

    if (DeploySliceData?.taskId?.payload) {
      // Call the API immediately on mount or when `DeploySliceData` changes
      dispatch(statusAiAgent(DeploySliceData?.taskId?.payload));
      // Set up an interval to call the API every minute (60000 ms)
      intervalId = setInterval(() => {
        dispatch(statusAiAgent(DeploySliceData?.taskId?.payload));
      }, 60000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [DeploySliceData, dispatch]);

  useEffect(() => {
    if (!deployAgentLoading && deployAgent) {
      dispatch(saveTaskId(deployAgent?.data?.task_id));
      dispatch(resetDeployAgent());
    }
  }, [deployAgent]);

  const handleRunAIAgent = () => {
    dispatch(deployAiAgent(slugName));
  };

  useEffect(() => {
    let intervalId;

    if (slugName) {
      // Call the API immediately on mount or when `DeploySliceData` changes
      dispatch(getProgressLoading(slugName));

      // Set up an interval to call the API every minute (60000 ms)
      intervalId = setInterval(() => {
        dispatch(getProgressLoading(slugName));
        dispatch(processedDocuments(slugName));
      }, 60000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(getStatisticsAgents(slugName));
    dispatch(processedDocuments(slugName));
  }, [slugName]);

  useEffect(() => {
    if (
      statusAgent?.data?.status === "SUCCESS" ||
      statusAgent?.data?.status === "Success"
    ) {
      dispatch(processedDocuments(slugName));
    }
  }, [statusAgent, receviedDatafromProps]);

  const startAction = () => {
    handleRunAIAgent();
    dispatch(getStatisticsAgents(slugName));
    dispatch(processedDocuments(slugName));
  };

  const getImages = (data) => {
    // Ensure field is always an object
    const name = data;

    if (name === "invoice") {
      return require("../assets/images/shelly.png");
    }
    if (name === "moad-so") {
      return require("../assets/images/debby.png");
    }
    if (name === "moad-w2") {
      return require("../assets/images/cindy.png");
    }
    if (name === "moad-pay-stub") {
      return require("../assets/images/raisa.png");
    }

    return require("../assets/images/alby.png"); // Default fallback image
  };

  const stats = [
    {
      label: "Total Files",
      value: `${progressindData?.total_files ?? 0}`,
      icon: <FolderCopyIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#5856d6",
      gradientTo: "#b8b6f6",
      statusKey: "all",
    },
    {
      label: "Processed Files",
      value: `${progressindData?.processed_files ?? 0}`,
      icon: <TaskIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#edad20",
      gradientTo: "#fce6a1",
      statusKey: "processed",
    },
    {
      label: "Rejected Files",
      value: `${progressindData?.rejected_files ?? 0}`,
      icon: <HighlightOffIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#da5d5c",
      gradientTo: "#f3b6b5",
      statusKey: "rejected",
    },
    {
      label: "Pending Files",
      value: `${progressindData?.pending_files ?? 0}`,
      icon: <HourglassEmptyIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#359aff",
      gradientTo: "#a8d4ff",
      statusKey: "pending",
    },
  ];
  // Sample data
  const tableData = processedDocumentsList;
  console.log("tableData", tableData);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const applyDurationFilter = (data, filter) => {
    const now = new Date();
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay()); // Sunday as start of the week

    switch (filter) {
      case "today":
        return data.filter((item) => {
          const date = new Date(item.created_at);
          return date >= startOfToday;
        });

      case "currentWeek":
        return data.filter((item) => {
          const date = new Date(item.created_at);
          return date >= startOfWeek;
        });

      case "currentMonth":
        return data.filter((item) => {
          const date = new Date(item.created_at);
          return (
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()
          );
        });

      case "last3Months":
        const threeMonthsAgo = new Date(now);
        threeMonthsAgo.setMonth(now.getMonth() - 3);
        return data.filter(
          (item) => new Date(item.created_at) >= threeMonthsAgo
        );

      case "last6Months":
        const sixMonthsAgo = new Date(now);
        sixMonthsAgo.setMonth(now.getMonth() - 6);
        return data.filter((item) => new Date(item.created_at) >= sixMonthsAgo);

      case "last1Year":
        const oneYearAgo = new Date(now);
        oneYearAgo.setFullYear(now.getFullYear() - 1);
        return data.filter((item) => new Date(item.created_at) >= oneYearAgo);

      case "all":
      default:
        return data;
    }
  };

  const filteredData = applyDurationFilter(
    statusFilter === "all"
      ? tableData
      : tableData.filter((row) => row.status === statusFilter),
    durationFilter
  );

  return statisticInfoLoading ? (
    <div className="agent-list-container">
      {[...Array(10)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={200}
          height={120}
          sx={{ borderRadius: "8px", marginBottom: "16px" }}
        />
      ))}
    </div>
  ) : (
    <Box sx={{ p: 2 }}>
      {/* Top Row: Back Arrow + Text */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          justifyContent: "space-between",
          marginRight: "50px",
        }}
      >
        <div style={{ flexDirection: "row", display: "flex" }}>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ArrowBackIcon
              sx={{ mr: 1, cursor: "pointer" }}
              onClick={() => {
                dispatch(resetDeployAgent());
                navigate("/LoadMyAgent");
              }}
            />
          </div>

          <div>
            <Typography variant="h6">Collecting</Typography>
          </div>
        </div>

        {(statusAgent?.data?.status === "SUCCESS" ||
          statusAgent?.data?.status === "Success") && (
          <Button
            variant="contained"
            onClick={startAction}
            sx={{
              backgroundColor: "#3B5CFF",
              color: "white",
              textTransform: "none",
              borderRadius: "999px",
              px: 3,
              py: 1,
              ml: 5,
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#3B5CFF",
              },
            }}
          >
            Start
          </Button>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          backgroundColor: "#f5f5f5",
          p: 2,
          borderRadius: 2,
        }}
      >
        <BlueTile
          title={`${profile?.first_name}\n`}
          subtitle={`${profile?.first_name} Agent\n${profile?.email}\nStatus: Sandbox`}
          imageSrc={getImages(statisticInfo?.data?.system_ai_agent?.slug)}
          containerStyles={{
            width: "500px",

            height: "165px",
            backgroundColor: profile?.first_name === "Policy" && "#2AD899",
          }}
          imageStyles={{
            width: "70px",
          }}
        />
        <Box sx={{ minWidth: 300 }}>
          <Box sx={{ position: "relative", ml: 5 }}>
            <DoughnutProgressCard
              value={progressindData?.progress_percentage ?? 0}
              label="Completion"
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, ml: 5 }}>
          <StatusProgress
            activeStep={
              statusAgent?.data?.status === "SUCCESS" ||
              statusAgent?.data?.status === "Success"
                ? 3
                : statusAgent?.data?.status === "PENDING" ||
                  statusAgent?.data?.status === "Pending"
                ? 2
                : 1
            }
          />

          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.5,
              borderRadius: "999px",
              backgroundColor:
                statusAgent?.data?.status === "SUCCESS" ||
                statusAgent?.data?.status === "Success"
                  ? "#2AD899"
                  : "#FFA000",
              color: "white",
              fontWeight: "bold",
              width: "fit-content",
            }}
          >
            <CheckCircleIcon sx={{ color: "white", fontSize: 20 }} />
            <Typography variant="body2">Success</Typography>
          </Box> */}
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <FormControl size="small" sx={{ minWidth: 150, marginRight: 12 }}>
          <Select
            value={durationFilter}
            onChange={(e) => setDurationFilter(e.target.value)}
            displayEmpty
            sx={{ borderRadius: 2 }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="currentWeek">Current Week</MenuItem>
            <MenuItem value="currentMonth">Current Month</MenuItem>
            <MenuItem value="last3Months">Last 3 Months</MenuItem>
            <MenuItem value="last6Months">Last 6 Months</MenuItem>
            <MenuItem value="last1Year">Last 1 Year</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Grid container spacing={1} sx={{ mt: 3 }}>
        {stats.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              onClick={() => setStatusFilter(item.statusKey)}
              sx={{
                position: "relative",
                overflow: "hidden",
                background: `linear-gradient(135deg, ${item.backgroundColor} 0%, ${item.gradientTo} 100%)`,
                boxShadow: `0 4px 12px ${item.backgroundColor}66`, // translucent shadow
                borderRadius: 2,
                width: "250px",
                height: "170%",
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 6,
                },
              }}
              elevation={3}
            >
              {/* Sparkline Background */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  height: "60%",
                  width: "100%",
                  opacity: 0.2,
                  zIndex: 0,
                }}
              >
                <Line data={sparklineData} options={sparklineOptions} />
              </Box>

              <CardContent
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                {item.icon}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: "bold", color: "#fff", fontSize: "30px" }}
                    variant="h6"
                  >
                    {item.value}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <TableContainer component={Paper} sx={{ width: "93%", marginTop: 15 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Agent Name", "File Name", "Status", ""].map((header, i) => (
                <TableCell
                  key={i}
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Avatar
                        src={getImages(row.ai_agent_slug)}
                        alt={row.ai_agent}
                        sx={{ width: 40, height: 40 }}
                      />
                      {row.ai_agent}
                    </Box>
                  </TableCell>
                  <TableCell>
  <DescriptionIcon sx={{ fontSize: 18, verticalAlign: 'middle', mr: 1 }} />
  {row.input_file_name}
</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        px: 2,
                        py: 0.5,
                        borderRadius: "999px",
                        backgroundColor:
                          row.status === "processed" || row.status === "success"
                            ? "#2AD899"
                            : row.status === "rejected"
                            ? "#C62828"
                            : "#F9A825",
                        color: "white",
                        fontWeight: "bold",
                        width: "100px",
                      }}
                    >
                      {/* <CheckCircleIcon sx={{ color: 'white', fontSize: 20 }} /> */}
                      <Typography variant="body2">
                        {row.status === "processed" || row.status === "success"
                          ? "Processed"
                          : row.status === "rejected"
                          ? "Rejected"
                          : "Pending"}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={
                        row.status === "rejected" ? (
                          <EditIcon />
                        ) : (
                          <VisibilityIcon />
                        )
                      }
                      sx={{
                        textTransform: "none",
                        fontFamily: "Poppins",
                        backgroundColor: (theme) => theme.palette.primary.main,
                        width: "80px",
                        justifyContent: "flex-start",
                        color: "white",
                        "&:hover": {
                          backgroundColor: (theme) =>
                            theme.palette.primary.dark,
                        },
                      }}
                      onClick={() =>
                        navigate("/ActivityDetailsScreen", {
                          state: {
                            row,
                            mode: row.status === "rejected" ? "edit" : "view",
                          },
                        })
                      }
                    >
                      <Typography
                        sx={{
                          fontSize: "12px",
                        }}
                      >
                        {row.status === "rejected" ? "Edit" : "View"}
                      </Typography>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default NewAgentViewerScreen;
